import { takeEvery, select } from 'redux-saga/effects'
import get from 'lodash/get'

import { lastAction as getLastAction } from 'store/entities/offline/selectors'
import { sendError } from '../actions'
import { googleException } from '../googleAnalytics'
import { ERRORS } from '../consts'

export function* handleError({ payload }) {
  const exception = {
    fatal: true,
  }

  // Back End Error (caught when request or response is wrong)
  if (payload && payload.response) {
    const lastAction = yield select(getLastAction)
    const url = get(payload, ['response', 'config', 'url'], 'NOT SET')
    const method = get(payload, ['response', 'config', 'method'], 'NOT SET')
    const error_id = get(payload, ['response', 'data', 'errorId'], 'NOT SET')
    const errorObject = {
      request_method: method,
      request_url: url,
      error_id,
      source: 'API',
    }
    if (lastAction) {
      errorObject.request_body = JSON.stringify(get(lastAction, ['payload', 'request', 'data']))
    } else {
      errorObject.request_body = JSON.stringify(get(payload, ['config', 'data']))
    }
    const res = payload.response
    errorObject.response_code = res.status
    errorObject.response_body = JSON.stringify(res.data)
    errorObject.payload = JSON.stringify(payload)

    exception.type = ERRORS.API_INTERACTION
    exception.description = errorObject
  } else if (get(payload, ['error'])) {
    // front End error
    const error = get(payload, 'error')
    exception.type = JSON.stringify(get(payload, 'type', ERRORS.APPLICATION_CRASHED))
    exception.description = {
      error: error instanceof Error ? JSON.stringify(error, Object.getOwnPropertyNames(error)) : 'Empty Error',
      info: JSON.stringify(get(payload, ['info'], 'NO INFO')),
    }
  } else {
    // Unknown error
    exception.type = ERRORS.UNKNOWN
    exception.description = {
      source: 'UI',
      error: payload instanceof Error ? JSON.stringify(payload, Object.getOwnPropertyNames(payload)) : 'Empty Error',
    }
  }

  googleException(exception)
}

export default function* errorSaga() {
  yield takeEvery(sendError.toString(), handleError)
}
